import { TableConfig } from '@shared/interfaces/table/table-config';
import { MeteringPointAdministrativePartyDto } from '@app/api/dmc';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { validFromPartialTable } from '@shared/partials/validfrom-partial.table';
import { validToPartialTable } from '@shared/partials/validto-partial.table';

export const meteringPointCoreDataColumns: TableConfig<MeteringPointAdministrativePartyDto> = {
  selectable: true,
  selectableType: 'single',
  columns: [
    {
      title: 'meteringpoint.coredata.addresstype',
      key: 'relationType',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        judicialaddress: "meteringpoint.coredata.addresstypes.judicialaddress",
        technicaladdress: "meteringpoint.coredata.addresstypes.technicaladdress",
      }
    },
    validFromPartialTable,
    validToPartialTable,
    {
      title: 'common.user.createdby',
      key: 'createdBy',
    },
    {
      title: 'common.user.modifiedby',
      key: 'modifiedBy'
    }
  ]
};
